import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Layout from './views';
import BonusCookie from './views/bonus_cookie';
import {Provider} from 'react-redux';
import Store from './lib/store';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Provider store={Store}>
      <Routes>
        <Route path="/bonus/:bonusToken" element={<BonusCookie />} />
        <Route path='*' element={<Layout />} />
      </Routes>
    </Provider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
